import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export async function tryRefresh() {
  try {
    refreshing = refreshing || api.post("/auth/refresh");
    await refreshing;
    return true;
  } catch {
    return false;
  } finally {
    refreshing = null;
  }
}

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      if (await tryRefresh()) return api(cfg);
    }
    return Promise.reject(error);
  }
);

export function errorCode(e) {
  if (!e?.response) return e?.code && /^[A-Z_]+$/.test(e.code) && e.code !== "ERR_NETWORK" ? e.code : "NETWORK";
  const d = e.response.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "VALIDATION";
  return "SERVER_ERROR";
}

export async function streamChat(payload, onEvent, signal) {
  const doFetch = () =>
    fetch(`${API}/chat/stream`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal,
    });
  let res = await doFetch();
  if (res.status === 401 && (await tryRefresh())) res = await doFetch();
  if (!res.ok) {
    let detail;
    try { detail = (await res.json()).detail; } catch { detail = null; }
    const err = new Error("http");
    err.code = typeof detail === "string" ? detail : "SERVER_ERROR";
    throw err;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const chunk = buf.slice(0, i);
      buf = buf.slice(i + 2);
      if (chunk.startsWith("data: ")) onEvent(JSON.parse(chunk.slice(6)));
    }
  }
}
